import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

// Display all Customer List
export const getCustomerList = createAsyncThunk('data/customer',
  async(data)=>{
    const res = await axiosInstance.get(`/api/v1/customer/getCustomer?page=${data.page}&limit=${data.limit}&search=${data.search}`);
      return res.data
  }
)

//Create Customer Details
export const createCustomerDetails = createAsyncThunk('data/createCustomer',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/customer/CreateCustomer', data);
      return res.data
  }
)

//Update Customer Details
export const updateCustomerDetails = createAsyncThunk('data/updateCustomer',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/customer/updateCustomer', data);
      return res.data
  }
)

//Delete Customer Details
export const deleteCustomerDetails = createAsyncThunk('data/deleteCustomerDetails',
  async(data)=>{
    const res = await axiosInstance.delete(`/api/v1/customer/deleteCustomer/${data}`);
      return res.data
    }
)
